import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "section__title" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row aling-items-center" }
const _hoisted_8 = { class: "col-4 offset-1" }
const _hoisted_9 = { class: "col-7" }
const _hoisted_10 = { class: "section__description" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "section__description underline" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "abaout-system-mobile" }
const _hoisted_18 = { class: "col-12 section__item" }
const _hoisted_19 = { class: "description" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_21 = { class: "col-12 section__item" }
const _hoisted_22 = { class: "description" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_24 = { class: "col-12 section__item" }
const _hoisted_25 = { class: "description" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_27 = { class: "col-12 section__item" }
const _hoisted_28 = { class: "description" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_30 = { class: "col-12 section__item" }
const _hoisted_31 = { class: "description" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_33 = { class: "col-12 section__item" }
const _hoisted_34 = { class: "description" }
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_36 = { class: "abaout-system-desktop" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-4 section__item" }
const _hoisted_39 = { class: "description" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_41 = { class: "col-4 section__item" }
const _hoisted_42 = { class: "description" }
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_44 = { class: "col-4 section__item" }
const _hoisted_45 = { class: "description" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_47 = { class: "col-4 section__item" }
const _hoisted_48 = { class: "description" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_50 = { class: "col-4 section__item" }
const _hoisted_51 = { class: "description" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)
const _hoisted_53 = { class: "col-4 section__item" }
const _hoisted_54 = { class: "description" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "dash-line" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('adaptiveTop.about')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_svg_icon, {
            name: "about-system",
            class: "section__image"
          })
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('main.mainAboutSystem')), 1),
          _createVNode(_component_router_link, {
            to: "/about-system",
            class: "link section__link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('main.next')) + " ", 1 /* TEXT */),
              _createVNode(_component_svg_icon, { name: "arrow-right" })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('main.mainTask')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_swiper, {
            "slides-per-view": _ctx.slidesPerView,
            "space-between": 40,
            loop: true,
            navigation: "",
            breakpoints: {
              // when window width is >= 480px
              576: {
                slidesPerView: 2,
                spaceBetween: 30
              },
              // when window width is >= 640px
              640: {
                slidesPerView: 3,
                spaceBetween: 40
              },
              1000: {
                slidesPerView: 6,
                spaceBetween: 40
              }
            },
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_18, [
                    _createVNode(_component_svg_icon, { name: "statistics-accounting" }),
                    _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('main.tour')), 1),
                    _hoisted_20
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_21, [
                    _createVNode(_component_svg_icon, { name: "Group" }),
                    _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('main.stat')), 1),
                    _hoisted_23
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_24, [
                    _createVNode(_component_svg_icon, { name: "Group1" }),
                    _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('main.analitics')), 1),
                    _hoisted_26
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_27, [
                    _createVNode(_component_svg_icon, { name: "teamwork" }),
                    _createVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('main.count')), 1),
                    _hoisted_29
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_30, [
                    _createVNode(_component_svg_icon, { name: "Group2" }),
                    _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('main.date')), 1),
                    _hoisted_32
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_33, [
                    _createVNode(_component_svg_icon, { name: "Group3" }),
                    _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('main.sum')), 1),
                    _hoisted_35
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["slides-per-view", "onSwiper", "onSlideChange"])
        ]),
        _createVNode("div", _hoisted_36, [
          _createVNode("div", _hoisted_37, [
            _createVNode("div", _hoisted_38, [
              _createVNode(_component_svg_icon, { name: "statistics-accounting" }),
              _createVNode("p", _hoisted_39, _toDisplayString(_ctx.$t('main.tour')), 1),
              _hoisted_40
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode(_component_svg_icon, { name: "Group" }),
              _createVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('main.stat')), 1),
              _hoisted_43
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode(_component_svg_icon, { name: "Group1" }),
              _createVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('main.analitics')), 1),
              _hoisted_46
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode(_component_svg_icon, { name: "teamwork" }),
              _createVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('main.count')), 1),
              _hoisted_49
            ]),
            _createVNode("div", _hoisted_50, [
              _createVNode(_component_svg_icon, { name: "Group2" }),
              _createVNode("p", _hoisted_51, _toDisplayString(_ctx.$t('main.date')), 1),
              _hoisted_52
            ]),
            _createVNode("div", _hoisted_53, [
              _createVNode(_component_svg_icon, { name: "Group3" }),
              _createVNode("p", _hoisted_54, _toDisplayString(_ctx.$t('main.sum')), 1),
              _hoisted_55
            ])
          ])
        ])
      ])
    ])
  ]))
}